import { useAuth } from "../../../usercontext";
import GlobalStudentLessonForGrade from "../../pages/common/globalstudentlessonforgrade";
import S12TopMenu from "../../student12/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";

export default function StudentLessonsForGrade() {
  const { profile } = useAuth();
  const slug = profile.id;
const isStudent911 = profile?.role === "Student911"
  return (
    <>
     {!isStudent911 && <S12TopMenu slug={slug} activeMenu="GradeList" />}
     {isStudent911 && <S911TopMenu slug={slug} activeMenu="GradeList" />}
       <GlobalStudentLessonForGrade slug={slug} isStudent={true} /> 
    </>
  );
}
